/**
 * Format seconds into MM:SS or HH:MM:SS format
 * 
 * @param seconds Number of seconds to format
 * @returns Formatted time string in MM:SS or HH:MM:SS format (if >= 1 hour)
 */
export function formatTime(seconds: number | null | undefined): string {
  // Handle invalid input
  if (typeof seconds !== 'number' || isNaN(seconds)) {
    console.warn('Invalid time value:', seconds);
    return '00:00';
  }
  
  // Ensure we never show 00:00 by returning 00:01 for zero or negative values
  if (seconds <= 0) {
    return '00:01';
  }
  
  // Calculate hours, minutes and seconds
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  // Format with leading zeros
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');
  
  // Return in HH:MM:SS format if >= 1 hour, otherwise MM:SS
  if (hours > 0) {
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
  return `${formattedMinutes}:${formattedSeconds}`;
}